export const WORK_ORDER_LIST = 'WORK_ORDER_LIST';
export const WORK_ORDER_LIST1 = 'WORK_ORDER_LIST1';
export const API_CALL_STATUS = 'API_CALL_STATUS';
export const IS_WORK_ORDER_LIST = 'IS_WORK_ORDER_LIST';
export const LOAD_TICKET_HISTORY = 'LOAD_TICKET_HISTORY';
export const SELECTED_DATA = 'SELECTED_DATA';
export const CLEAR_WORK_ORDER_STORE_INFO = "CLEAR_WORK_ORDER_STORE_INFO";
export const COMING_FROM_QUOTATION = "COMING_FROM_QUOTATION";
export const CLEAR_MESSAGESS = "CLEAR_MESSAGESS"